/**
 * Analytics Dashboard
 * Análises e métricas da plataforma
 */
export default function Analytics() {
  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-white">Analytics</h1>
        <p className="text-slate-400">Métricas e análises da plataforma</p>
      </div>
      
      <div className="admin-card">
        <div className="text-center py-12">
          <p className="text-slate-400">Em desenvolvimento...</p>
        </div>
      </div>
    </div>
  )
}

